import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Sidebar, Segment, Menu, Icon } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import 'semantic-ui-css/semantic.min.css';
import history from '../history'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import moment from 'moment'

import * as paths from '../constants'
import * as userActions from '../actions/user'
import { getPlanPermissions } from '../actions/plan_permission'
import { getTranslations } from '../actions/language'
import { getText } from '../helpers';
import Feedback from '../components/feedback'
import SystemHeader from '../components/system_header'
import UserFormModal from '../components/user_form_modal'
import ConfirmModal from '../components/confirm_modal'
import '../App.css';
import TagsDropdown from '../components/tags_dropdown'
import PermissionsTable from '../components/permissions_table'
import ElementLoader from '../components/element_loader'
import ObjectITButton from '../components/developed_by_objectit';

class Users extends Component {
  constructor(props){
    super(props);

    this.state = {
      sidebarShown: false,
      pendingMessage: "",
      notifications: "",
      columns: this.createColumns(),
      users: [],
      user: {},
      userFormMode: 'new',
      userFormShown: false,
      confirmDeleteShown: false,
      language: this.props.language,
      languages: this.props.languages,
      translations: this.props.language.translations,
      languageName: this.props.language.name,
      rowEvents: {
        onClick: this.editUser
      },
      searchTerm: '',
      userTagOptions: [],
      tagFilters: [],
      permissionsTableState: {
        selectAllEdit: false,
        selectAllView: false,
        planPermissions: [],
      },
      loading: false,
    }

  }

  componentWillMount = () => {
    if (!this.props.signedIn) {
      return history.push(paths.LOGIN_PATH)
    }
  }

  componentDidMount = () => {
    this.setSystemTexts();
    this.getUsers();
    this.getUserTags()
  }

  componentWillReceiveProps = (nextProps) => {
    if (this.props.createPending && !nextProps.createPending && !nextProps.error) {
        this.getUsers()
        this.getUserTags()
        this.resetUserForm()
    }

    if (this.props.updatePending && !nextProps.updatePending && !nextProps.error) {
      this.getUsers()
      this.getUserTags()
      this.resetUserForm()
      this.resetUserPlanPermissionTable()
    }
  }

  tagsFormatter = (cell, row) => {
    return <div className='cell-style' onClick={e => e.stopPropagation()}>
      {
        row.tag_list.length > 0 &&
        <span className='tags-container'>
          {
            row.tag_list.map((tag, index)=>{
              return(
                <span key={index} className='tag user-tag'>
                  {tag}&nbsp;
                  <i aria-hidden="true"
                     className="delete icon"
                     onClick={e =>this.onRemoveTag(tag, row)}></i>
                </span>
              )
            })
          }
        </span>
      }
     </div>
  }

  onRemoveTag = (tag, row) => {
    var tagList = row.tag_list
    if (tagList.includes(tag)) {
      var index = tagList.indexOf(tag);
      if (index !== -1) tagList.splice(index, 1);
    }
    this.onApplyTags(tagList, row)
  }

  createColumns = () => {
    return [
      {
        dataField: 'profile',
        text: this.props.language.translations.name,
        formatter: this.nameFormatter,
        headerTitle: true,
        headerStyle: {
          width: '13%'
        },
        editable: false,
      },
      {
        dataField: 'email',
        text: `${this.props.language.translations.email}/${this.props.language.translations.username}`,
        formatter: this.cellFormatter,
        headerTitle: true,
        editable: false,
        headerStyle: {
          width: '22%'
        },
      },
      {
        dataField: 'tags',
        text: `${this.props.language.translations.user_tags}`,
        formatter: this.tagsFormatter,
        headerTitle: true,
        editable: false,
        headerStyle: {
          width: '21%'
        },
      },
      {
        dataField: 'is_admin',
        text: this.props.language.translations.access,
        formatter: this.accessFormatter,
        headerTitle: true,
        editable: false,
        headerStyle: {
          width: '16%'
        },
      },
      {
        dataField: 'updated_at',
        text: this.props.language.translations.last_modified,
        formatter: this.dateFormatter,
        headerStyle: {
          width: '13%'
        },
        headerTitle: true,
        title: true,
        editable: false
      },
      {
        dataField: 'created_at',
        text: this.props.language.translations.date_created,
        formatter: this.dateFormatter,
        headerStyle: {
          width: '13%'
        },
        headerTitle: true,
        title: true,
        editable: false
      },
      {
        dataField: 'buttons',
        text: '',
        formatter: this.actionsFormatter,
        headerStyle: {
          width: '14%'
        },
        headerTitle: true,
        title: true,
        editable: false
      },
    ]
  }

  setSystemTexts = () => {
    this.props.getTranslations('English').then(()=>{
      this.setState({
        language: this.props.language,
        languages: this.props.languages,
        translations: this.props.language.translations,
        languageName: this.props.language.name,
        columns: this.createColumns()
      })
    })
  }

  getUsers = () => {
    this.setState({ loading: true })
    var options = {
      search_term: this.state.searchTerm,
      tag_filters: this.state.tagFilters
    }
    this.props.getUsers(options).then(()=>{
      this.setState({
        users: this.props.users,
        loading: false,
      })
    })
  }

  getUserTags = () => {
    this.props.getUserTags().then(() => {
      this.setState({
        userTagOptions: this.props.userTags
      })
    })
  }

  cellFormatter = (cell, row) => {
    return (
     <div className='cell-style' title={cell}>
      { cell }
     </div>
    );
  }

  nameFormatter = (cell, row) => {
    return (
     <div className='cell-style'>
      {
        cell &&
        <span title={`${cell.first_name} ${cell.last_name}`}>{ `${cell.first_name} ${cell.last_name}` }</span>
      }
     </div>
    );
  }

  accessFormatter = (cell, row) => {
    return (
     <div className='cell-style'>
      {
        cell &&
        <span className='tags-container'>
          <span className='tag'>{this.state.translations.admin_access}</span>
        </span>
      }
     </div>
    )
  }

  dateFormatter = (cell, row) => {
    cell = moment(cell).format("DD MMM YYYY hh:mm A")
    return (
     <div className='cell-style' title={cell}>
      { cell }
     </div>
    );
  }

  onApplyTags = (tag_list, row) => {
    row.tag_list = tag_list
    const user_params = {
      id: row.id,
      tag_list: row.tag_list,
      update_mode: 'tag_list',
    }
    this.props.updateUser(user_params)
  }

  onNewTag = (tag) => {
    var userTagOptions = this.state.userTagOptions
    if (!userTagOptions.includes(tag)){
      userTagOptions.splice(0,0,tag)
      this.setState({
        tagOptions: userTagOptions
      })
    }
  }

  actionsFormatter = (cell, row) => {
    const { tags, tag_as, delete_label, edit } = this.state.translations
    const trigger = <a className='plan-action'>{tags}</a>

    return (
     <div className='cell-style'>
      <a className='plan-action' onClick={(evt)=>this.editUser(evt, row)}>{edit}</a>
      <a className='plan-action red' onClick={(evt)=>this.onDeleteUser(evt, row)}>{delete_label}</a>
      {
        <TagsDropdown
         className='tags-dropdown'
         trigger={trigger}
         header={`${tag_as}:`}
         translations={this.state.translations}
         tagList={row.tag_list}
         onApply={ tag_list => this.onApplyTags(tag_list, row)}
         tagOptions={this.state.userTagOptions}
         onNewTag={this.onNewTag}
         addable={true}
         searchable={true}
        />
      }
      { !row.role_names.includes('admin') &&
        <a className='plan-action' onClick={this.editUserPlanPermission.bind(this, row)}>{"Permissions"}</a>
      }
     </div>
    );
  }

  editUserPlanPermission(user, e){
    e.stopPropagation()
    this.setState({ permissionsTableModalOpen: true,
                    userFormMode: 'edit_plan_permissions',
                    user: user })

    this.props.getPlanPermissions({ model: "User", model_id: user.id}).then(() => {
      const permissionsTableState = {...this.state.permissionsTableState}
      permissionsTableState.planPermissions = this.props.planPermissions

      const can_update_all = !permissionsTableState.planPermissions.some( p => !p.can_update )
      if(can_update_all){
        permissionsTableState.selectAllEdit = true
        permissionsTableState.selectAllView = true
      } else {
        const can_read_all = !permissionsTableState.planPermissions.some( p => !p.can_read )
        if(can_read_all){
          permissionsTableState.selectAllView = true
        }
      }

      this.setState({ permissionsTableState: permissionsTableState })
    })
  }

  closePlanPermissionsTable = permissionsTableState => {
    if(permissionsTableState){
      this.updateUserPlanPermission(permissionsTableState)
      return
    }

    this.resetUserPlanPermissionTable()
  }

  updateUserPlanPermission = permissionsTableState => {
    if( this.state.user.role_names.includes('admin') ){ return }

    let planPermissions = []
    if( permissionsTableState.selectAllEdit ) {
      planPermissions = ['update_all']
    } else {
      planPermissions = permissionsTableState.planPermissions.map( permission => {
        return { can_read: permission.can_read, can_update: permission.can_update,
                 plan_id: permission.plan_id, id: permission.id }
      });
    }

    this.saveUser({
      id: this.state.user.id,
      plan_permissions: planPermissions,
      update_mode: 'plan_permissions'
    })
  }

  resetUserPlanPermissionTable = () => {
    this.setState({
      permissionsTableModalOpen: false,
      userFormMode: "",
      permissionsTableState: {
        selectAllEdit: false,
        selectAllView: false,
        planPermissions: [],
      }
    });
  }

  toggleSideBar = () => {
    this.setState({ sidebarShown: true })
  }

  hideSideBar = () => {
    if (this.state.sidebarShown) {
      this.setState({ sidebarShown: false })
    }
  }

  onSearch = (evt) => {
    this.setState({
      searchTerm: evt.target.value
    }, ()=>{
      this.getUsers()
    })
  }

  clearFilters = (evt) => {
    this.setState({
      searchTerm: '',
      tagFilters: [],
    }, ()=>{
      this.getUsers()
    })
  }

  toggleUserForm = (evt) => {
    this.setState({
      userFormShown: !this.state.userFormShown
    }, ()=>{
      if (!this.state.userFormShown) {
        this.getUsers();
      }
    })
  }

  addUser = (evt) => {
    this.props.clearUserError();
    this.setState({
      userFormShown: true,
      userFormMode: 'new'
    })
  }

  editUser = (e, row, rowIndex) => {
    this.props.clearUserError();
    this.setState({
      userFormShown: true,
      userFormMode: 'edit',
      user: row
    })
  }

  saveUser = (user) => {
    if( this.state.userFormMode === 'new' ){
      this.props.createUser(user);
    } else {
      this.props.updateUser(user);
    }
  }

  resetUserForm = () => {
    this.setState({
      userFormShown: false,
      userFormMode: '',
    })
  }

  onDeleteUser = (evt, user) => {
    evt.stopPropagation()
    this.setState({
      user: user,
      confirmDeleteShown: true
    })
  }

  toggleConfirmDelete = (evt) => {
    this.setState({
      confirmDeleteShown: !this.state.confirmDeleteShown
    })
  }

  deleteUser = (user) => {
    this.props.deleteUser(user).then(()=>{
      this.getUsers()
      this.toggleConfirmDelete()
    })
  }

  onFilterByTags = (tags) => {
    this.setState({
      tagFilters: tags,
      loading: true
    })
    const options = {
      search_term: this.state.searchTerm,
      tag_filters: tags
    }
    this.props.getUsers(options).then(()=>{
      this.setState({
        users: this.props.users,
        tagFilters: tags,
        loading: false,
      })
    })
  }

  removeFromTagFilters = (tag) => {
    var tagList = this.state.tagFilters
    if (tagList.includes(tag)) {
      var index = tagList.indexOf(tag);
      if (index !== -1) tagList.splice(index, 1);
    }
    this.onFilterByTags(tagList)
  }

  render(props) {
    const { sidebarShown, users, rowEvents, columns, translations } = this.state

    return (
      <div className="App">
        <Sidebar.Pushable as={Segment}>
          <Sidebar
            as={Menu}
            animation='overlay'
            width='thin'
            visible={sidebarShown}
            icon='labeled'
            vertical
            inverted
            onMouseLeave={() => this.hideSideBar()}
          >
            <Menu.Item name='home' as={Link} to={paths.DASHBOARD_PATH + '/risk_templates'}>
              <span className="sidebar-button-wrap"><Icon name='file alternate'></Icon><div>{getText('Edit Template')}</div></span>
            </Menu.Item>            
            <Menu.Item name='plans' as={Link} to={paths.DASHBOARD_PATH + '/risk_plans'}>
              <span className="sidebar-button-wrap"><Icon name='file alternate'></Icon><div>{getText('Open Plan')}</div></span>
            </Menu.Item>
            <Menu.Item name='control-inventory' as={Link} to={paths.LIBRARY_CONTROLS_PATH}>
              <span className="sidebar-button-wrap"><Icon name='file'></Icon><div>{getText('Control Library')}</div></span>
            </Menu.Item>
            <Menu.Item className='selected' name='users' as={Link} to={paths.USERS_PATH}>
              <span className="sidebar-button-wrap"><Icon name='users'></Icon><div>{getText('Manage Users')}</div></span>
            </Menu.Item>
            <Menu.Item name='send_feedback' onClick={()=>{}}>
              <span className="sidebar-button-wrap"><Feedback translations={this.state.translations}/></span>
            </Menu.Item>
            <Menu.Item>
              <ObjectITButton />
            </Menu.Item>
          </Sidebar>
          <Sidebar.Pusher>
            <Segment basic>
              <SystemHeader
                toggleSideBar={this.toggleSideBar}
                notifications={this.state.notifications}
                pendingMessage={this.state.pendingMessage}
                showLogout={true}
                view='users'
                showMenuButton={true}
                showLanguage={false}
              />
              <Menu>
                <Menu.Item
                  name='toolbar-item'
                  className='toolbar-item users-toolbar'
                >
                  <a className='plan-action' onClick={this.addUser}><i aria-hidden="true" className="add icon"></i>{translations.add_user}</a>
                  <form autoComplete="off">
                    <div className="ui input">
                      <input type="text" placeholder={translations.search_users} value={this.state.searchTerm} onChange={this.onSearch} />
                    </div>
                  </form>
                  {
                    <TagsDropdown
                     className='tags-dropdown'
                     trigger={(<a className='plan-action'>{translations.filter_by_tags}</a>)}
                     header={`${translations.filter_as}:`}
                     translations={this.state.translations}
                     tagList={this.state.tagFilters}
                     onApply={this.onFilterByTags}
                     tagOptions={this.state.userTagOptions}
                     addable={false}
                     searchable={true}
                    />
                  }
                  {
                    this.state.tagFilters.length > 0 &&
                    <span className='tags-container'>
                      {
                        this.state.tagFilters.map((tag, index)=>{
                          return(
                            <span key={index} className='tag user-tag'>{tag} <i aria-hidden="true" className="delete icon" onClick={(evt)=>this.removeFromTagFilters(tag)}></i></span>
                          )
                        })
                      }
                    </span>
                  }
                  {
                    (this.state.searchTerm.length > 0 || this.state.tagFilters.length > 0 )&&
                    <a className='plan-action' onClick={this.clearFilters}>{translations.clear_filters}</a>
                  }
                </Menu.Item>
              </Menu>
              <div className="risks-table position-relative" id="users-table" style={{ display: 'block' }}>
                <ElementLoader isLoading={this.state.loading} />

                <BootstrapTable
                  tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }}
                  keyField="id"
                  data={ users }
                  columns={ columns }
                  striped
                  hover
                  condensed
                  rowEvents={rowEvents}
                />
                {
                  users.length === 0 &&
                  <span className="no-data-indication"><i className="file alternate icon"></i>{translations.no_users_found}</span>
                }
              </div>
              {
                this.state.userFormShown &&
                <UserFormModal
                  open={this.state.userFormShown}
                  mode={this.state.userFormMode}
                  user={this.state.user}
                  onSave={this.saveUser}
                  translations={this.state.translations}
                  userTagOptions={this.state.userTagOptions}
                  close={this.toggleUserForm}
                  getPlanPermissions={this.props.getPlanPermissions}
                  planPermissions={this.props.planPermissions}
                  isLoading={ this.props.createPending || this.props.updatePending}
                  error={this.props.error}
                />
              }
              {
                this.state.confirmDeleteShown &&
                <ConfirmModal
                  open={this.state.confirmDeleteShown}
                  header={translations.confirm_delete}
                  message={translations.confirm_delete_user}
                  onProceed={()=>this.deleteUser(this.state.user)}
                  translations={this.state.translations}
                  close={this.toggleConfirmDelete}
                />
              }
              { this.state.permissionsTableModalOpen &&
                <PermissionsTable
                  user={this.state.user}
                  open={this.state.permissionsTableModalOpen}
                  translations={this.state.translations}
                  permissionsTableState={this.state.permissionsTableState}
                  close={this.closePlanPermissionsTable}
                  formMode={this.state.userFormMode}
                />
              }
            </Segment>
          </Sidebar.Pusher>
        </Sidebar.Pushable>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    users: state.user.users,
    user: state.user.user,
    error: state.user.error,
    createPending: state.user.createPending,
    updatePending: state.user.updatePending,
    token: state.app_token.accessToken,
    signedIn: state.app_token.signedIn,
    isAdmin: state.app_token.isAdmin,
    language: state.language.language,
    languages: state.language.languages,
    userTags: state.user.user_tags,
    planPermissions: state.plan_permission.planPermissions,
    instanceConfig: state.instance.instanceConfig
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getUsers: (options) => dispatch(userActions.getUsers(options)),
    createUser: (user) => dispatch(userActions.createUser(user)),
    updateUser: (user) => dispatch(userActions.updateUser(user)),
    deleteUser: (user) => dispatch(userActions.deleteUser(user)),
    clearUserError: () => dispatch(userActions.clearUserError()),
    getTranslations: (name) => dispatch(getTranslations(name)),
    getUserTags: options => dispatch(userActions.getUserTags(options)),
    getPlanPermissions: options => dispatch(getPlanPermissions(options))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Users);



// WEBPACK FOOTER //
// ./src/views/users.js